import { useIFramePage } from 'shared/features/iframe-page';
import { NotificationsIFrameHeader } from '../components';
import { useErxNotificationsUrl } from './useErxNotificationsUrl';
export var useNotificationsIFrame = function () {
    var _a;
    var _b = useErxNotificationsUrl(), data = _b.data, isLoading = _b.isLoading;
    return useIFramePage({
        iframeUrl: (_a = data === null || data === void 0 ? void 0 : data.ssoUrl) !== null && _a !== void 0 ? _a : null,
        isLoading: isLoading,
        header: NotificationsIFrameHeader,
    });
};
